import layer from 'vue-layer-mobile'
import {nError} from './notice'
import {errorMessage} from './errorCode'
import {isResponse} from './util'
// import {isResponse} from './util'

const errorHandler = message => error => {
  Promise.resolve(generateErrorInfo(message)(error))
    .then((data) => {
      if (data) {
        if (data.tip && data.tip !== '') {
          nError(data.tip)
        }
      }
    })
}

const theExceptionIsReturnedByServer = (error, also) => {
  return {
    also,
    fromServer: true,
    level: 0,
    type: '',
    error
  }
}

const theExceptionIsGeneratedByClient = (error) => {
  return error
}

const generateErrorInfo = message => error => {
  console.log(message)
  console.log(error.response)
  let err = JSON.stringify(error)
  let res = JSON.parse(err)

  if (error.response) {
    if (error.response.data.data) {
      if (+error.response.data.data === 91007 || error.response.data.data === '91007') {
        sessionStorage.clear()
        window.$$vm.$router.push({
          name: 'login'
        })
      }
      if (+error.response.data.data > 0) {
        let TipData = errorMessage(+error.response.data.data)
        return {
          tip: TipData,
          fullStack: theExceptionIsReturnedByServer(error)
        }
      } else {
        return {
          tip: error.response.data.data,
          fullStack: theExceptionIsReturnedByServer(error)
        }
      }
    }
  }
  if (isResponse(error)) {
    if (error.status === 401 || error.status === 403) {
      return {
        tip: null,
        fullStack: theExceptionIsReturnedByServer(error)
      }
    }
    if (error.status === 409) {
      return error.json()
      // .then(() => {
      //   window.history.go(-1)
      // })
        .then(error => {
          window.history.go(-1)
          let TipData = errorMessage(+error.data)
          return {
            tip: TipData,
            fullStack: theExceptionIsReturnedByServer(error)
          }
        })
    }
    if (error.status >= 400 && error.status < 500) {
      if (res.body) {
        if (+res.body.data > 0) {
          let TipData = errorMessage(+res.body.data)
          if (+res.body.data === 91007) {
            sessionStorage.clear()
            window.$$vm.$router.push({
              name: 'login'
            })
          }
          return {
            tip: TipData,
            fullStack: theExceptionIsReturnedByServer(error)
          }
        }
      } else if (error) {
        return error.json()
          .then(error => {
            if (+error.data === 91007) {
              sessionStorage.clear()
              window.$$vm.$router.push({
                name: 'login'
              })
            }
            if (+error.data > 0) {
              return {
                tip: errorMessage(+error.data),
                fullStack: theExceptionIsReturnedByServer(error)
              }
            } else {
              return {
                tip: message,
                fullStack: theExceptionIsReturnedByServer(error)
              }
            }
          })
      } else {
        return {
          tip: res.data.data,
          fullStack: theExceptionIsReturnedByServer(error)
        }
      }
    }
    if (error.status >= 500) {
      if (error.json) {
        error = error.json()
      }
      return {
        tip: message,
        fullStack: theExceptionIsReturnedByServer(error)
      }
    }
    if (error.status !== 200) {
      const also = `无法识别的HTTP状态码${error.status}`
      if (error.json) {
        error = error.json()
      }
      return {
        tip: message,
        fullStack: theExceptionIsReturnedByServer(error, also)
      }
    }
    error = error.json()
  }

  // 不存在error对象
  if (!error) {
    return {
      tip: message,
      fullStack: theExceptionIsGeneratedByClient(message)
    }
  }

  // error 为具体的 Error对象
  if (error instanceof Error && error._message_) {
    return {
      tip: error._message_,
      fullStack: theExceptionIsGeneratedByClient(error)
    }
  }

  // 貌似一切正常
  if (error.msg === 'success' && error.retCode === 1) {
    return {
      tip: null,
      fullStack: theExceptionIsGeneratedByClient({
        message: '',
        error
      })
    }
  }

  if (error.msg === 'fail' && error.retCode === 0 && error.data) {
    if (+error.data === 91007) {
      sessionStorage.clear()
      window.$$vm.$router.push({
        name: 'login'
      })
    }
    let tip = ''
    if (+error.data > 0) {
      tip = errorMessage(+error.data)
    } else {
      tip = error.data
    }
    return {
      tip: tip,
      fullStack: theExceptionIsReturnedByServer(error, '服务端使用了旧的错误返回机制')
    }
  }

  return {
    tip: message,
    fullStack: theExceptionIsGeneratedByClient(error)
  }
}

export const loge = e => e && console.error(e)

export const createAnErrorWithTip = (tipInfo, message) => {
  const error = new Error(message || tipInfo)
  error._message_ = tipInfo
  return error
}

export const ifNullGenerateTipping = message => data => {
  if (!data) {
    return Promise.reject(createAnErrorWithTip(message))
  }
  return data
}

export default errorHandler
export {errorHandler}



// WEBPACK FOOTER //
// ./src/utils/errorHandler.js